import { render } from "./ListReceptionsActionButtonsRenderer.vue?vue&type=template&id=02e2b90a"
import script from "./ListReceptionsActionButtonsRenderer.vue?vue&type=script&lang=js"
export * from "./ListReceptionsActionButtonsRenderer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__